<template>
    <div class="contents">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-main user-member justify-content-sm-between">
                        <div class="d-flex flex-wrap justify-content-center breadcrumb-main__wrapper">
                            <div class="d-flex align-items-center user-member__title justify-content-center mr-sm-25">
                                <h4 class="text-capitalize fw-500 breadcrumb-title">Detail Node Server</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <div v-if="!isLoading"
                        class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                        <form v-on:submit.prevent="editNodeServer">
                            <label for="">Server URL*</label>
                            <input type="text" class="form-control" v-model="form.server_url" placeholder="http://localhost:3000" required />
                            <br>
                            <label for="">Multidevice*</label>
                            <select v-model="form.multidevice" class="form-control" required>
                                <option :value="0">Single Device</option>
                                <option :value="1">Multi Device</option>
                            </select>
                            <br>
                            <label for="">Token*</label>
                            <input type="text" class="form-control" v-model="form.token" placeholder="Token" required />
                            <br>
                            <label for="">Status*</label>
                            <select v-model="form.active" class="form-control" required>
                                <option :value="0">Tidak Aktif</option>
                                <option :value="1">Aktif</option>
                            </select>
                            <br>
                            <div class="button-group d-flex pt-25">
                                <button type="submit"
                                    class="btn btn-primary btn-block btn-default btn-squared text-capitalize mx-auto d-block">
                                    simpan
                                </button>
                            </div>
                        </form>
                    </div>
                    <div v-else class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                        <center>
                            <div class="spinner-border spinner" role="status"></div>
                        </center>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                id: '',
                form: {
                    server_url: null,
                    multidevice: 0,
                    token: null,
                    active: 1,
                },
                isLoading: true,
            };
        },
        async mounted() {
            this.id = this.$route.query.id
            await this.loadData()
        },
        methods: {
            async editNodeServer(){
                try{
                    let req = {
                        id: this.id,
                        server_url: this.form.server_url,
                        multidevice: parseInt(this.form.multidevice),
                        token: this.form.token,
                        active: parseInt(this.form.active),
                    }

                    let response = await this.$store.dispatch('admin_node_server_update', req)
                    this.$toast.success(response.data.message);

                    await this.loadData()
                }catch(err){
                    this.$toast.error(err.response?.data?.message || "Failed to update node server");
                }
            },
            async loadData() {
                try {
                    let id = this.$route.query.id
                    let detail = await this.$store.dispatch("admin_node_server_detail", {
                        id: id
                    })
                    let serverData = detail.data.data.node_server

                    this.form = {
                        server_url: serverData.url || serverData.server_url,
                        multidevice: serverData.multidevice,
                        token: serverData.token,
                        active: serverData.active,
                    }

                    this.isLoading = false
                } catch (err) {
                    this.$toast.error(err.response?.data?.message || "Failed to load node server")
                    this.$router.push("/admin/node-server")
                }
            },
        },
    };
</script>



